import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.staging';
import { Region } from '../shared/interfaces/interfaces';

interface Configuration {
  pubNub: {
    publishKey: string;
    subscribeKey: string;
    ssl: true
  };
  stage: string;
  haystackUrl: string;
  alertsUrl: string;
  ssapUrl: string;
  omnitrixUrl: string;
  loggingUrl: string;
  auth: {
    caretakerUrl: string,
    gatekeeperUrl: string,
    appSecret: string
  };
}

@Injectable({
  providedIn: 'root'
})
export class ConfigurationService {
  private readonly CONFIG_URL = 'assets/config/config.json';
  appConfig: any = {};
  regionsList: Region[] = environment.regions || [];
  selectedRegion: string = '';
  constructor(private http: HttpClient) { }

  loadAppConfig() {
    return this.http.get<Configuration>(this.CONFIG_URL)
      .toPromise()
      .then(data => {
        this.appConfig = data;
      });
  }

  setConfig(data: any) {
    this.appConfig = data;
  }

  getConfig(key: any) {
    return this.appConfig[key];
  }

  setRegionList(regions: Region[]) {
    this.regionsList = regions;
  }

  getRegions() {
    return this.regionsList;
  }

  setSelectedRegion(regionId: string) {
    this.selectedRegion = regionId;
  }
  
  getSelectedRegion() {
    return this.selectedRegion;
  }
}
